// src/components/DeleteAccountRequest.js
import React, { useState } from "react";
import "./DeleteAccountRequest.css";

const DeleteAccountRequest = () => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here, e.g., sending data to the server
    console.log("Delete account request submitted for:", phoneNumber);
    alert("Your request to delete your account has been submitted.");
    setPhoneNumber(""); // Reset the form
  };

  return (
    <div className="delete-account-container">
      <div className="header-banner">
        <h1>Request to Delete Account</h1>
        <p>We’re sorry to see you go! Enter your phone number to submit a deletion request.</p>
      </div>

      <form className="delete-account-form" onSubmit={handleSubmit}>
        <label htmlFor="phoneNumber">Phone Number</label>
        <input
          type="tel"
          id="phoneNumber"
          name="phoneNumber"
          placeholder="Enter your phone number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          required
        />
        <button type="submit">Submit Request</button>
      </form>
    </div>
  );
};

export default DeleteAccountRequest;
